module.exports = __webpack_public_path__ + "static/media/form2B.ca372e85.pdf";